import { render, staticRenderFns } from "./subProject.vue?vue&type=template&id=d9fdc3ce&scoped=true&"
import script from "./subProject.vue?vue&type=script&lang=js&"
export * from "./subProject.vue?vue&type=script&lang=js&"
import style0 from "./subProject.vue?vue&type=style&index=0&id=d9fdc3ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fdc3ce",
  null
  
)

export default component.exports